// Note, these are not actionCreators, just regular functions.

import axios from 'axios';
import config from '../../config';
import { makeAPICall } from '../generalCreators';

export function humanFileSize(fileSizeInBytes) {
  var i = -1;
  var byteUnits = [' kB', ' MB', ' GB', ' TB', 'PB', 'EB', 'ZB', 'YB'];
  do {
      fileSizeInBytes /= 1024;
      i++;
  } while (fileSizeInBytes > 1024);

  return Math.max(fileSizeInBytes, 0.1).toFixed(1) + byteUnits[i];
};

export function getUrlAndUpload(file, token, organisationId) {
  const url = `${config.RMRDigitalAPI}/shapeset/uploadurl/${file.name}`;
  const options = {
    method: 'GET',
    headers: { token },
    params: { productId: config.productId }
  }

  if (organisationId) {
    options.params.organisationId = organisationId;
  }

  return axios(url, options).then((response) => {
    return uploadFileToS3(file, response.data);
  });
}

export function uploadFileToS3(file, url) {
  const options = {
    method: 'PUT',
    data: file,
    headers : { 'Content-Type': 'application/octet-stream' },
  }
  return axios(url, options);
}

export function uploadShapes(files, token, shapeSetId, organisationId=undefined) {
  return new Promise(function(resolve, reject) {
    const allFiles = files.map((file, index) => getUrlAndUpload(file, token, organisationId));

    axios.all(allFiles).then(
      response => {
        processShapeFiles(files, shapeSetId, token, organisationId).then(success =>(resolve(success)),
          failure => reject(failure))
      },
      error => reject(error)
    )
  });
}

export function processShapeFiles(files, shapeSetId, token, organisationId = undefined) {
  const file = files[0]; // there should only be one file
  const endpoint = `/shapeset/process/${shapeSetId}`;
  const options = {
    method: 'PUT',
    headers: { token },
    params: { productId: config.productId },
    data: { shapeSetName: file.name }
  };

  if (organisationId) {
    options.params.organisationId = organisationId;
  }

  return makeAPICall(endpoint, options).then(
    response => {console.log(response); return response;},
    error => {console.log('error: ', error); return Promise.reject(error);}
  );
}



// WEBPACK FOOTER //
// ./src/actions/shapeSets/uploadHelpers.js